'use strict';

angular.module('licensure.services')
    .factory('LicenseScheduledTasks', ['$http', '$q', 'Enterprise', function ($http, $q, Enterprise) {

        return {

            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenseScheduledTasks/', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenseScheduledTasks/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCertificationIDs: function (scheduled_task_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licenseScheduledTasks/getCertificationIDs', {
                        params: {
                            scheduled_task_id: scheduled_task_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCertifications: function (certsArray) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licenseScheduledTasks/getCertifications';

                $http({
                    method: method,
                    url: url,
                    data: {
                        certsArray: certsArray
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_scheduled_task) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licenseScheduledTasks/';
                if (!isUndefined(license_scheduled_task.id)) {
                    method = 'PUT';
                    url += license_scheduled_task.id;
                }

                Enterprise.get({ enterpriseID: license_scheduled_task.enterprise_id }).then(function (enterprise) {
                    var timeString = license_scheduled_task.frequency_begin_time == null ? "12:00:00" : license_scheduled_task.frequency_begin_time.toString();
                    var begin_time_hours = timeString.substr(0, 2);
                    var begin_time_minutes = timeString.substr(timeString.indexOf(":") + 1, 2);
                    var begin_date_time_string = new Date(1900, 0, 1, parseInt(begin_time_hours), parseInt(begin_time_minutes)).toString();
                    var date_string = new Date(begin_date_time_string).toLocaleString();
                    var frequency_begin_date = new Date(date_string);

                    Date.prototype.subtractHours = function (h) {
                        this.setTime(this.getTime() - (h * 60 * 60 * 1000));
                        return this;
                    }

                    frequency_begin_date.subtractHours(enterprise.server_spec.utc_to_server_hours);
                    // British English uses 24-hour time without AM/PM
                    var frequency_begin_time = frequency_begin_date.toLocaleTimeString('en-GB');
                    license_scheduled_task.frequency_begin_time = frequency_begin_time;

                    $http({
                        method: method,
                        url: url,
                        data: {
                            license_scheduled_task: license_scheduled_task,
                            license_scheduled_task_criteria_statuses: license_scheduled_task.license_scheduled_task_criteria_statuses,
                            license_scheduled_task_criteria_levels: license_scheduled_task.license_scheduled_task_criteria_levels,
                            license_scheduled_task_merge_templates: license_scheduled_task.license_scheduled_task_merge_templates,
                            license_scheduled_task_createalerts: license_scheduled_task.license_scheduled_task_createalerts,
                            license_scheduled_task_retirealerts: license_scheduled_task.license_scheduled_task_retirealerts
                        }
                    })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            // handle error
                        });
                });

                return d.promise;
            },

            saveStatuses: function (license_category_id, license_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/licenseScheduledTasks/saveStatuses', {
                    params: {
                        license_category_id: license_category_id,
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            saveLevels: function (license_category_id, license_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/licenseScheduledTasks/saveLevels', {
                    params: {
                        license_category_id: license_category_id,
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/licenseScheduledTasks/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            run: function (scheduled_task_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/licenseScheduledTasks/run', {
                    params: {
                        scheduled_task_id: scheduled_task_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });
                return d.promise;
            }
        }
    }])
    ;